<template>
  <div>
    <vx-card>
      <heading size="h1" style-size="h4" class="mb-5">Communication</heading>
      <p class="mb-5">
        Communication Skills are important to practice during your work experience placement. Here
        are some ideas to help you make the most of the opportunity to hone your communication
        skills while on work placement.
      </p>

      <div class="vs-row" style="display: flex; width: 100%">
        <div class="vs-col vs-xs-12 vs-sm-8 vs-lg-9">
          <h5 class="text-bold mb-5">Be an effective listener</h5>

          <p class="mb-5">
            Listen carefully to any instructions you are given and don't interrupt. You are there to
            learn, so listening skills are imperative for your learning and to follow instructions
            effectively.
          </p>
          <p class="mb-5">
            Clarify immediately if you are not sure about something. Employers prefer that you ask
            questions rather than guess or underperform.
          </p>
          <p class="mb-5">
            Pay attention to what is happening around you. You don't want to make avoidable
            mistakes. Being aware of what is happening in your surrounding environment helps you
            respond quickly and show initiative - all traits that are guaranteed to impress your
            boss!
          </p>

          <h5 class="text-bold mb-5">
            Display the characteristics of a person with an open attitude
          </h5>

          <p class="mb-5">
            Developing these characteristics will go a long way to helping you earn respect in the
            workplace, ensure a positive reference, and even potentially secure future work
            opportunities:
          </p>
          <p class="mb-5">To display these positive characteristics at work, try to:</p>
          <ul class="default-list">
            <li>
              Be friendly, open, willing to learn, enthusiastic, a good listener, confident, prompt,
              courteous, and hard working.
            </li>
            <li>
              Make others comfortable around you by communicating openly and freely, having a sense
              of humour, and contributing enthusiastically even with the most mundane and boring
              aspects of the job.
            </li>
            <li>Do your share willingly and without complaint.</li>
            <li>
              Admit to any mistakes straight away. Don't blame others or try to cover up errors, as
              this only makes you look immature and dishonest.
            </li>
            <li>Expect the unexpected!</li>
          </ul>
          <h5 class="text-bold mb-5">Develop strong workplace relationships</h5>

          <p class="mb-5">
            Relationships at work are different from those you form elsewhere. You will often spend
            a lot of time with people you wouldn't normally choose to spend time with! Work is not
            essentially a social situation. It is advantageous and desirable to be friendly at work,
            but your main focus should be on establishing constructive and professional
            relationships. Don't let your personal feelings (good or bad) interfere with performing
            the job successfully.
          </p>
          <p class="mb-5">
            If there is a conflict with an individual, try to focus on the task at hand and less on
            that person's behaviour. You still must find a way to work together.
          </p>
        </div>
        <div class="vs-col vs-xs-12 vs-sm-4 vs-lg-3 lg:pl-10 sm:pl-5">
          <img
            src="@/assets/images/workplace_preparation/new/communication.jpg"
            class="img-responsive"
            alt=""
          />
        </div>
      </div>

      <form id="form" class="mt-10" @submit.prevent="save">
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-checkbox v-model="data.confirmed" name="confirmed"
              >I have read all the information in this module</vs-checkbox
            >
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full flex justify-between">
            <div>
              <button class="btn btn-primary btn-size-medium mr-3 mb-1">Submit</button>
              <router-link
                to="/student/workplace-preparation"
                class="btn btn-secondary btn-size-medium mb-1"
              >
                Back
              </router-link>
            </div>
          </div>
        </div>
      </form>
    </vx-card>
  </div>
</template>

<script>
export default {
  computed: {
    data: {
      get: function () {
        return this.getModuleData();
      },
      set: function (d) {
        this.setModuleData(d);
      },
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    isConfirmed() {
      return this.$store.getters['authStudent/preworkWorkplacePreparationModules'][
        this.$route.params.id
      ];
    },
    prework() {
      return this.$store.getters['authStudent/prework'];
    },
  },
  methods: {
    save() {
      this.saveModule(this.data);
    },
  },
  watch: {
    'prework.workplace_preparation_modules'() {
      const modules = this.prework.workplace_preparation_modules;
      if (modules && modules[4]) {
        this.data = modules[4];
      }
    },
  },
  mounted() {
    if (this.isConfirmed) this.data.confirmed = true;
  },
  beforeDestroy() {
    this.data.confirmed = false;
  },
  inject: ['saveModule', 'getModuleData', 'setModuleData'],
};
</script>
